import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';

export default function Logout() {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark logout</span>
                    <span className={Styles.CommandSummary}>Remove saved credentials</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Removes the saved authentication token from <code>~/.modelpark/config.json</code>.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Example</div>
                        <div className={Styles.CodeBlock}>
                            <code>modelpark logout</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>Logged out successfully</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
